
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"162","height":"162","viewBox":"0 0 162 162","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_31_3598)","fill":"#324997"}},[_c('path',{attrs:{"d":"M152 140.35c-1.109 2.408-3.003 3.092-5.573 3.088-35.253-.056-70.507-.069-105.76-.037-3.798 0-5.236-1.449-5.236-5.284v-11.364h1.723c28.232 0 56.467.01 84.704.03 4.116 0 7.518-1.331 10.462-4.19 8.072-7.836 13.956-17.14 18.538-27.365.351-.79.739-1.56 1.109-2.34L152 140.35zM152 43.525H35.56a8.996 8.996 0 01-.11-.984c0-3.746-.02-7.488 0-11.234 0-2.715 1.7-4.416 4.407-4.438h20.505V22.96c.03-2.588 1.745-4.411 4.145-4.415 2.4-.004 4.116 1.816 4.153 4.412.019 1.242 0 2.485 0 3.82h20.771v-3.86c.034-2.59 1.787-4.394 4.19-4.372 2.404.022 4.068 1.808 4.109 4.316.022 1.287 0 2.57 0 3.93h21.041v-3.779c.022-2.614 1.697-4.437 4.093-4.467 2.459-.026 4.179 1.805 4.205 4.497v3.827h1.479c5.998 0 11.996.082 17.99-.04 2.548-.056 4.379.74 5.436 3.091L152 43.525z"}}),_c('path',{attrs:{"d":"M35.35 51.926h116.502c-.151 2.496-.225 4.966-.466 7.421-1.161 11.997-3.99 23.56-9.123 34.498-3.831 8.169-8.69 15.639-15.017 22.125a7.71 7.71 0 01-5.983 2.518c-35.332-.061-70.667-.071-106.005-.029-1.77 0-3.298-.37-4.322-1.923a4.024 4.024 0 01.573-5.203c13.113-12.961 19.713-29.07 22.557-46.964.588-3.698.77-7.436 1.139-11.156.044-.422.092-.825.144-1.287z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_31_3598"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h142v142H0z"}})])])])
          )
        }
      }
    